module.exports = "/_next/static/images/780c8ac002384ce964d029063c2fc184-young-people-walking@0.5x.jpg";